import React from 'react';
import { ViewHandler } from '../../../documents/types';
import { CptCodesView } from '../../../documents/form/views/cpt/CptCodesView';
import {
    CPT_TASK_LOG_TONE,
    isCptTaskLogCptCodesField,
} from '../../../documents/form/views/cpt/constants';

export const cptViewHandlers: Record<string, ViewHandler> = {
    cptCodes: ({ value, field, updateData }) => (
        <CptCodesView
            value={value}
            sumField={field.viewProps?.sumField || 'minutes'}
            onCodesChange={(codes) => updateData?.('cptCodes', codes)}
            {...field.viewProps}
            tone={
                isCptTaskLogCptCodesField(field.id)
                    ? CPT_TASK_LOG_TONE
                    : undefined
            }
        />
    ),
};
